import type { SVGProps } from "react";

interface BottomNavIconProps extends SVGProps<SVGSVGElement> {
    isActive?: boolean;
}

export function HomeIcon( { isActive = false, className, ...props }: BottomNavIconProps ) {
    return (
        <svg
            className={className}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M14.2698 3.002C12.8857 2.02986 11.0398 2.03334 9.6594 3.01068L4.1245 6.92942C3.06535 7.67931 2.43582 8.89642 2.43586 10.1942L2.43609 17.5989C2.43616 19.808 4.227 21.5988 6.43609 21.5988H17.5637C19.7728 21.5988 21.5637 19.808 21.5637 17.5988L21.5637 10.2036C21.5637 8.90062 20.9291 7.67927 19.8628 6.93034L14.2698 3.002Z"
                fill="currentColor"
            />
            <path
                d="M8.1615 15.5214L10.7942 12.8886L12.3481 15.0305L15.2013 12.1813"
                stroke={isActive ? "var(--ui-content-fixed-inverse)" : "var(--ui-surface-base)"}
                strokeOpacity="0.95"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M14.0923 11.0723H16.3103V13.2903"
                stroke={isActive ? "var(--ui-content-fixed-inverse)" : "var(--ui-surface-base)"}
                strokeOpacity="0.95"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export function LiveIcon( { isActive = false, className, ...props }: BottomNavIconProps ) {
    return (
        <svg
            className={className}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M9.55737 13.7047V11.5929C9.55737 10.8231 10.3907 10.342 11.0574 10.7269L12.8862 11.7827L14.715 12.8386C15.3817 13.2235 15.3817 14.1858 14.715 14.5707L12.8862 15.6266L11.0574 16.6824C10.3907 17.0673 9.55737 16.5862 9.55737 15.8164V13.7047Z"
                fill="currentColor"
            />
            <rect x="2.39941" y="5.76746" width="19.199" height="15.8318" rx="4" fill="currentColor" />
            <rect
                x="6.95874"
                y="2.83264"
                width="1.5"
                height="6.82703"
                rx="0.75"
                transform="rotate(-30.0467 6.95874 2.83264)"
                fill="currentColor"
            />
            <rect
                width="1.5"
                height="6.82703"
                rx="0.75"
                transform="matrix(-0.865618 -0.500705 -0.500705 0.865618 17.0391 2.83264)"
                fill="currentColor"
            />
            <path
                d="M14.4907 12.8576C15.0719 13.2546 15.0719 14.1119 14.4907 14.5089L11.6374 16.4584C10.9736 16.9119 10.0732 16.4366 10.0732 15.6328L10.0732 11.7337C10.0732 10.9299 10.9736 10.4545 11.6374 10.908L14.4907 12.8576Z"
                fill={isActive ? "var(--ui-content-fixed-inverse)" : "var(--ui-surface-base)"}
            />
        </svg>
    );
}

export function SearchIcon( { isActive = false, className, ...props }: BottomNavIconProps ) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            className={className}
            {...props}
        >
            <path
                d="M19.1877 19.1882L14.6279 14.6284"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M10.5621 16.3127C13.7378 16.3127 16.3122 13.7383 16.3122 10.5626C16.3122 7.3869 13.7378 4.8125 10.5621 4.8125C7.38641 4.8125 4.81201 7.3869 4.81201 10.5626C4.81201 13.7383 7.38641 16.3127 10.5621 16.3127Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export function PortfolioIcon( { isActive = false, className, ...props }: BottomNavIconProps ) {
    return (
        <svg
            className={className}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M11.2533 19.7366C11.6242 19.8407 11.6479 20.3574 11.2882 20.4952L9.75278 21.0833C7.55279 21.9259 5.10469 20.6943 4.46997 18.4256L2.62808 11.842C2.04862 9.77076 3.21123 7.61318 5.26105 6.96208C5.88383 6.76427 6.44595 6.58591 6.85194 6.45714C7.14406 6.36449 7.42738 6.62138 7.36393 6.92121L5.79807 14.3205C5.36166 16.3827 6.60041 18.4296 8.62972 18.9996L11.2533 19.7366Z"
                fill="currentColor"
            />
            <rect
                x="9.43713"
                y="1.91589"
                width="13.2905"
                height="15.6989"
                rx="4"
                transform="rotate(12.333 9.43713 1.91589)"
                fill="currentColor"
            />
            <path
                d="M12.4161 8.78918L17.1493 9.82403"
                stroke={isActive ? "var(--ui-content-fixed-inverse)" : "var(--ui-surface-base)"}
                strokeWidth="1.5"
                strokeLinecap="round"
            />
            <path
                d="M11.6206 12.4282L14.5328 13.0649"
                stroke={isActive ? "var(--ui-content-fixed-inverse)" : "var(--ui-surface-base)"}
                strokeWidth="1.5"
                strokeLinecap="round"
            />
        </svg>
    );
}

export function MeIcon( { isActive = false, className, ...props }: BottomNavIconProps ) {
    return (
        <svg
            className={className}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M12.0021 2.3999C6.69935 2.3999 2.40051 6.69874 2.40051 12.0015C2.40051 17.3042 6.69935 21.6009 12 21.6009C17.3006 21.6009 21.5994 17.3021 21.5994 12.0015C21.5994 6.70088 17.3049 2.3999 12.0021 2.3999Z"
                fill="currentColor"
            />
            <path
                d="M16.2539 11.9404C16.8061 11.9405 17.2638 12.3924 17.1599 12.9348C16.6952 15.3615 14.5613 17.1953 11.999 17.1953C9.43687 17.1953 7.30299 15.3616 6.83821 12.9349C6.73433 12.3925 7.19206 11.9405 7.74434 11.9405C10.6815 11.9404 13.3131 11.9401 16.2539 11.9404Z"
                fill={isActive ? "var(--ui-content-fixed-inverse)" : "var(--ui-surface-base)"}
            />
        </svg>
    );
}

export function RankIcon( { isActive = false, className, ...props }: BottomNavIconProps ) {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" className={className} {...props}>
            <path
                d="M11.9978 14.6973C14.5509 14.6973 16.6207 12.5667 16.6207 9.9385V4.68115H7.375V9.9385C7.375 12.5667 9.44472 14.6973 11.9978 14.6973Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.37485 11.2303V7.37793H4.29297C4.29297 9.94618 5.83391 11.2303 7.37485 11.2303Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16.6211 11.2303V7.37793H19.703C19.703 9.94618 18.162 11.2303 16.6211 11.2303Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M11.998 15.4673V17.0082"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M8.53125 19.3197L9.95277 17.0083H13.9409L15.4655 19.3197H8.53125Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export function ChatIcon( { isActive = false, className, ...props }: BottomNavIconProps ) {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" className={className} {...props}>
            <path
                d="M19 12C19 15.866 15.866 19 12 19C9.90928 19 5 19 5 19C5 19 5 13.7753 5 12C5 8.134 8.13402 5 12 5C15.866 5 19 8.134 19 12Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M9 11H15" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M9 14H12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}

export function ReferralIcon( { isActive = false, className, ...props }: BottomNavIconProps ) {
    return (
        <svg
            className={className}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <circle cx="10.9261" cy="12.7161" r="6.40945" stroke="#77808D" strokeWidth="1.5" />
            <path
                d="M14.3579 5.83203C14.7346 5.52473 15.2693 5.52474 15.646 5.83203L15.7241 5.90234L15.7485 5.92871L18.5054 8.9502H18.5044C18.6784 9.13816 18.7248 9.35185 18.7397 9.44141C18.7582 9.55176 18.7564 9.65132 18.7563 9.6748C18.7563 9.78611 18.7505 10.1376 18.4438 10.458L18.4458 10.46L15.689 13.4268C15.6825 13.4337 15.6761 13.4406 15.6694 13.4473C15.5461 13.5701 15.4074 13.6305 15.3325 13.6582C15.2405 13.6922 15.1393 13.7152 15.0356 13.7246C14.8563 13.7409 14.5044 13.7266 14.2241 13.4473C14.1671 13.3904 14.1196 13.324 14.0835 13.252C14.0333 13.1519 13.9931 13.0473 13.9702 12.9336C13.9472 12.8192 13.9487 12.7249 13.9487 12.6963V11.8379C13.3273 11.9544 12.6398 12.2733 12.0073 12.748C11.1281 13.4082 10.5215 14.2427 10.3706 14.9287C10.3153 15.1801 10.1352 15.3862 9.89307 15.4736C9.65095 15.5611 9.38041 15.5184 9.17725 15.3604C8.93771 15.1739 8.81628 14.9192 8.74951 14.7314C8.67867 14.5321 8.63812 14.3168 8.61377 14.1172C8.565 13.7172 8.56685 13.2679 8.57861 12.8926C8.63065 11.2326 9.56932 9.88915 10.7397 8.98535C11.6873 8.2537 12.8429 7.76273 13.9487 7.60547V6.70898C13.9487 6.68068 13.942 6.51089 14.0015 6.33301C14.0674 6.13618 14.1843 5.99749 14.2798 5.90234L14.3579 5.83203Z"
                fill={isActive ? "var(--ui-content-fixed-inverse)" : "var(--ui-surface-base)"}
                stroke="#77808D"
                strokeWidth="1.5"
                strokeLinejoin="round"
            />
            <circle cx="19.5162" cy="6.98841" r="0.715945" fill="#77808D" />
            <circle cx="8.7772" cy="5.49155" r="1.36704" fill="#77808D" />
            <circle cx="19.1594" cy="15.9372" r="1.07392" fill="#77808D" />
            <circle cx="19.1583" cy="12.3575" r="0.357972" fill="#77808D" />
            <circle cx="11.9996" cy="4.48248" r="0.357972" fill="#77808D" />
            <circle cx="17.3693" cy="4.84046" r="0.715945" fill="#77808D" />
        </svg>
    );
}
